const FORM_ELEMENTS = ['INPUT', 'SELECT', 'BUTTON', 'TEXTAREA', 'DATALIST', 'KEYGEN', 'OUTPUT'];

export default (active, controls) => {
  const ret = {
    activeIdx: -1,
    active: null,
    controls,
  };
  const shuffleActive = control => {
    const idx = controls.indexOf(control);
    if (idx) {
      ret.activeIdx = idx;
      ret.active = control;
      ret.controls = [...controls.slice(idx + 1), ...controls.slice(0, idx)];
      return true;
    }
    return false;
  };

  if (active && FORM_ELEMENTS.indexOf(active.tagName) === -1) {
    Array.from(active.querySelectorAll(FORM_ELEMENTS.join(','))).some(shuffleActive);
  } else {
    shuffleActive(active);
  }

  return ret;
};
